import { Box, Tooltip, TooltipProps } from '@chakra-ui/react';
import { useRef } from 'react';

// THIS COMPONENT IS A WORKAROUND BC OF WEBPACK UPGRADES
export const TooltipWrapper = ({
    children,
    label,
    isDisabled,
    placement = 'bottom-start',
    hasArrow = true,
    portalProps = { appendToParentPortal: true },
    ...rest
}: TooltipProps): JSX.Element => {
    const triggerRef = useRef<HTMLDivElement>(null);

    return (
        <Tooltip
            label={label}
            isDisabled={isDisabled}
            placement={placement}
            hasArrow={hasArrow}
            portalProps={portalProps}
            {...rest}
        >
            <Box ref={triggerRef}>{children}</Box>
        </Tooltip>
    );
};
